/**
 * Enforces optional product metafield custom.required_qty on bundle add-ons (PDP + cart).
 * Allowed quantities: 0, or any integer >= required_min (when required_min >= 2).
 * Invalid values in 1..required_min-1 snap to 0. Plus from 0 jumps to required_min.
 */
(function () {
  'use strict';

  function parseMin(attr) {
    if (attr == null || attr === '') return null;
    var n = parseInt(attr, 10);
    return Number.isFinite(n) && n >= 2 ? n : null;
  }

  function normalizeChange(q, min) {
    if (min == null) return q;
    if (!Number.isFinite(q) || q < 0) return 0;
    if (q === 0) return 0;
    if (q < min) return 0;
    return q;
  }

  function normalizeAdd(q, min) {
    if (min == null) return q;
    if (!Number.isFinite(q) || q < 0) return 0;
    if (q === 0) return 0;
    if (q < min) return 0;
    return q;
  }

  function findAddonWrapByVariantId(variantId) {
    var v = String(variantId);
    var input = document.querySelector(
      'form.complementary-product-form input[name="id"][value="' + v + '"]'
    );
    return input ? input.closest('[data-complementary-addon]') : null;
  }

  function bindMinQtyControls(scopeEl, min) {
    if (scopeEl.__requiredMinQtyBound) return;
    var sel = scopeEl.querySelector('[data-quantity-selector]');
    if (!sel) return;
    scopeEl.__requiredMinQtyBound = true;

    var input = sel.querySelector('[data-quantity-input]');
    var plus = sel.querySelector('[data-quantity-plus]');
    var minus = sel.querySelector('[data-quantity-minus]');
    var minusWrap = sel.querySelector('[data-button-wrapper-minus]');
    var addonCheckbox = scopeEl.querySelector('input.complementary-product__addon-checkbox');
    if (!input || !plus || !minus) return;

    var inc = parseInt(input.getAttribute('data-increment-value'), 10) || 1;

    function updateMinusState() {
      var c = parseInt(input.value, 10) || 0;
      if (!minusWrap) return;
      if (c <= 0) {
        minusWrap.classList.add('quantity-selector__button-wrapper--disabled');
      } else {
        minusWrap.classList.remove('quantity-selector__button-wrapper--disabled');
      }
    }

    function setVal(n) {
      input.value = String(n);
      if (addonCheckbox) {
        addonCheckbox.checked = n > 0;
      }
      updateMinusState();
    }

    plus.addEventListener(
      'click',
      function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var c = parseInt(input.value, 10) || 0;
        var next = min != null && c === 0 ? min : c + inc;
        setVal(next);
      },
      true
    );

    minus.addEventListener(
      'click',
      function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var c = parseInt(input.value, 10) || 0;
        var next;
        if (min != null) {
          next = c <= min ? 0 : c - inc;
        } else {
          next = c <= 0 ? 0 : c - inc;
        }
        setVal(next);
      },
      true
    );

    input.addEventListener(
      'change',
      function () {
        var raw = parseInt(input.value, 10);
        var n = normalizeChange(Number.isFinite(raw) ? raw : 0, min);
        if (min == null && (!Number.isFinite(n) || n < 0)) {
          n = 0;
        }
        if ((parseInt(input.value, 10) || 0) !== n) {
          input.value = String(n);
        }
        updateMinusState();
      },
      true
    );

    updateMinusState();
  }

  function bindComplementaryAddonQty() {
    document.querySelectorAll('[data-complementary-addon]').forEach(function (wrap) {
      bindMinQtyControls(wrap, parseMin(wrap.getAttribute('data-required-min-qty')));
    });
  }

  function patchFetch() {
    var orig = window.fetch;
    if (orig.__requiredMinQtyPatched) return;
    function wrappedFetch(url, opts) {
      try {
        if (typeof url === 'string' && opts && opts.body && typeof opts.body === 'string') {
          if (url.indexOf('/cart/change.js') !== -1) {
            var d = JSON.parse(opts.body);
            if (d.id != null && d.quantity != null) {
              var row;
              document.querySelectorAll('[data-cartitem-key]').forEach(function (el) {
                if (el.getAttribute('data-cartitem-key') === String(d.id)) row = el;
              });
              var min = row && parseMin(row.getAttribute('data-required-min-qty'));
              if (min != null) {
                var nq = normalizeChange(parseInt(d.quantity, 10), min);
                d.quantity = nq;
                opts = Object.assign({}, opts, { body: JSON.stringify(d) });
              }
            }
          } else if (url.indexOf('/cart/add.js') !== -1) {
            var payload = JSON.parse(opts.body);
            if (payload.items && Array.isArray(payload.items)) {
              var mapped = payload.items.map(function (item) {
                var wrap = findAddonWrapByVariantId(item.id);
                var min = wrap && parseMin(wrap.getAttribute('data-required-min-qty'));
                var q = parseInt(item.quantity, 10);
                var nq = normalizeAdd(q, min);
                var props = item.properties ? Object.assign({}, item.properties) : {};
                if (min != null) {
                  props._required_min_qty = String(min);
                }
                return Object.assign({}, item, {
                  quantity: nq,
                  properties: props,
                });
              });
              var head = mapped[0];
              var tail = mapped
                .slice(1)
                .filter(function (line) {
                  return parseInt(line.quantity, 10) > 0;
                });
              payload.items = head ? [head].concat(tail) : tail;
              opts = Object.assign({}, opts, { body: JSON.stringify(payload) });
            }
          }
        }
      } catch (e) {
        /* use original request */
      }
      return orig.call(this, url, opts);
    }
    wrappedFetch.__requiredMinQtyPatched = true;
    window.fetch = wrappedFetch;
  }

  function initBindings() {
    bindComplementaryAddonQty();
  }

  function init() {
    patchFetch();
    initBindings();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    initBindings();
  });

  window.addEventListener('cartcount:update', function () {
    setTimeout(initBindings, 0);
  });
})();
